export const BU_ACTION_TYPES = {
    FETCH_BUSINESS_UNITS_START: 'bu/FETCH_BUSINESS_UNITS_START',
    FETCH_BUSINESS_UNITS_SUCCESS: 'bu/FETCH_BUSINESS_UNITS_SUCCESS',
    FETCH_BUSINESS_UNITS_FAILED: 'bu/FETCH_BUSINESS_UNITS_FAILED',
};